import Vue from 'vue';
import Icon from '@/components/common/icon';
import LrLink from '@/components/common/lr-link';
import Breadcrumb from '@/components/common/breadcrumb';
import Pagination from '@/components/common/pagination';
import Badge from '@/components/common/badge';
import CloseBtn from '@/components/common-btns/close-btn';

import toast from '@/components/common/toast';
import dialogPop from '@/components/common/dialog-pop/index';

import { translateCrowd, getYYYYMMDD, getmmss } from '@/common/utils/index';
import xss from 'xss';

const eventBus = new Vue();

Vue.component('icon', Icon);
Vue.component('lr-link', LrLink);
Vue.component('breadcrumb', Breadcrumb);
Vue.component('pagination', Pagination);
Vue.component('badge', Badge);
Vue.component('close-btn', CloseBtn);

Vue.filter('crowd', translateCrowd);
Vue.filter('YYYYMMDD', getYYYYMMDD);
Vue.filter('mmss', getmmss);

Vue.prototype.$toast = toast;
Vue.prototype.$dialogPop = dialogPop;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$checkAuth = function () {
  const isLogin = !!this.$store.state.user.userInfo;
  if (!isLogin) {
    this.$eventBus.$emit('login');
  }
  return isLogin;
};
// v-html xss，增加白名单
Vue.prototype.$xss = xss;

//预请求svg组件(通过之前的svg-sprite-loader加载)
const req = require.context('@/assets/image/icon/custom_icon', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
